export default __webpack_public_path__ + "static/media/calender.1af65d76.svg";